export default function uniqueID() {
	return new Date().getTime().toString().concat(performance.now())
}
